import "./ProgressBar.scss";

const ProgressBar = ({
    percentage = 0,
    label,
    value,
    height = 8,
    width = "100%",
    ...props
}) => {
    const progressStyle = {
        width: `${Math.min(Math.max(percentage, 0), 100)}%`,
    };

    return (
        <div className="progress-bar" style={{ width }} {...props}>
            {label && (
                <div className="progress-bar__header">
                    <span className="progress-bar__label">{label}</span>
                    <span className="progress-bar__values">
                        <span className="progress-bar__percentage">
                            {percentage}%
                        </span>
                        {value && (
                            <span className="progress-bar__value">{value}</span>
                        )}
                    </span>
                </div>
            )}

            <div className="progress-bar__container" style={{ height }}>
                <div className="progress-bar__fill" style={progressStyle} />
            </div>
        </div>
    );
};

export default ProgressBar;
